export default __webpack_public_path__ + "static/media/Factory_Bg-Loop.dc692c99.mp4";